import { useToast } from '@/common-utils/hooks/use-toast';
import { useEffect, useRef } from 'react';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { nsSession } from '@/app/i18n/namespaces';

const useReloadPage = (getLastBuildDataResponse, showModalReloadPage, setShowModalReloadPage, showNotificationUpdate, setShowNotificationUpdate, isCustomPay) => {

    // Toast
    const { toast } = useToast();

    // Constants
    // Check updates every 15 minutes
    const CHECK_UPDATES_DELAY = 15 * 60 * 1000;
    // Force automatic update after 5 minutes
    const AUTO_UPDATE_DELAY = 5 * 60 * 1000;
    // Delay to display a notification with a notice of the upcoming automatic update: 1 minute before the end
    const AUTO_UPDATE_NOTIFICATION_DELAY = AUTO_UPDATE_DELAY - 1 * 60 * 1000;

    // Refs
    // To access the previous value of getLastBuildDataResponse.data, use a ref to store the previous value across renders.
    const prevLastBuildDataRef = useRef();

    // Hooks
    // On mount set interval to check for updates
    useEffect(() => {
        setInterval(getLastBuildDataResponse.refetch, CHECK_UPDATES_DELAY);
    }, []);

    // On change of getLastBuildDataResponse.data, check if the current version is different from the one in the previous render
    useEffect(() => {
        // Set previous value if not set
        if (!prevLastBuildDataRef.current) {
            prevLastBuildDataRef.current = getLastBuildDataResponse.data;
        }

        // Check if new data is available
        if (getLastBuildDataResponse.data) {
            const { lastBuildTimestamp, lastBuildVersions } = getLastBuildDataResponse.data;
            const { lastBuildTimestamp: prevLastBuildTimestamp, lastBuildVersions: prevLastBuildVersions } = prevLastBuildDataRef.current;

            if (lastBuildTimestamp !== prevLastBuildTimestamp && lastBuildVersions !== prevLastBuildVersions) {
                const [clientVersion, clientVersionCustomPay] = lastBuildVersions.split(':');
                if (!isCustomPay) {
                    setShowModalReloadPage(true);
                } else if (clientVersion === clientVersionCustomPay && isCustomPay) {
                    setShowModalReloadPage(true);
                }
            }
            prevLastBuildDataRef.current = getLastBuildDataResponse.data;
        }
    }, [getLastBuildDataResponse.data]);

    // On change of showModalReloadPage, show the modal and set the interval to reload the page
    useEffect(() => {
        if (showModalReloadPage) {
            setTimeout(() => {
                window.location.reload();
            }, AUTO_UPDATE_DELAY);
            setInterval(() => {
                if (!showNotificationUpdate) {
                    setShowNotificationUpdate(true);
                }
            }, AUTO_UPDATE_NOTIFICATION_DELAY);
        }
    }, [showModalReloadPage]);

    // On change of showNotificationUpdate, show the notification
    useEffect(() => {
        if (showNotificationUpdate) {
            toast({
                description: <Entity entity='toast.reload_page.message' namespace={nsSession} />,
                variant: 'warning'
            });
        }
    }, [showNotificationUpdate]);

};

export default useReloadPage;